// extracted by mini-css-extract-plugin
export default {"container":"QCPRM5","back-office":"CKLwFf","backOffice":"CKLwFf","success":"EdzGzM","error":"vcU6xU","info":"A1e1WH","center":"E1Fz0F","static":"B58XC1","close":"Us6ADw"};